import React from 'react';
import {connect} from 'react-redux';
import {useAdminstratorResults} from './administratorResultsHelper';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useResultsTableDimensions, useBoolean, useToggle} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import AdministratorWizard from '../../Wizards/AdministratorWizard';
import {isAdminReadOnlySelector, isUserMultiDomainAdminSelector} from '../../../store/selectors/user.selectors';
import AdministratorFilterPane from '../../Filters/AdministratorFilterPane';
import {helpContextPageUrl} from '../../../conf/Routes';
import SMCTableActions from '../../../components/core/SMCTableActions/SMCTableActions';
import {AdministratorFilterSchema} from '../../../api/DBSchema/Administrator';

function AdministratorResults({
    isAdminReadOnly,
    isUserMultiDomainAdmin
}) {

    const [tableWidth, tableHeight] = useResultsTableDimensions();
    const [isNewObjectWindowOpen, openNewObjectWindow, closeNewObjectWindow] = useBoolean(false);
    const [isFilterPaneOpen, toggleFilterPane] = useToggle(false);
    
    const {
        columns,
        columnsState,
        setColumnsState,
        setDefaultColumnsState,
        tableContent,
        rowIdSelector,
        fetchNextPage,
        isFetching,
        isLastPage,
        isPageLoaded,
        filterObject,
        setFilterObject,
        freeTextSearch,
        selectedObjects,
        setSelectedObjects,
        sortBasis,
        sortDirection,
        setSort,
        columnsWidths,
        setColumnsWidths,
        newObjectCallback,
        deleteButtonOnClick,
        reloadButtonOnClick,
    } = useAdminstratorResults();

    const hasCreatePermissions = !isAdminReadOnly && !isUserMultiDomainAdmin;
    const hasDeletePermissionste = !isAdminReadOnly && !isUserMultiDomainAdmin;

    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.administratorResults}>
            <div className="DrawResultsDiv">
                <SMCTableActions
                        openNewObjectWindow={openNewObjectWindow}
                        reloadButtonOnClick={reloadButtonOnClick}
                        deleteButtonOnClick={deleteButtonOnClick}
                        toggleFilterPane={toggleFilterPane}
                        canCreate={hasCreatePermissions}
                        canDelete={hasDeletePermissionste}
                        isFetching={isFetching} 
                        tableContent={tableContent}
                        isFilterPaneOpen={isFilterPaneOpen}
                        selectedObjects={selectedObjects}
                        initialSearch={filterObject} 
                        onSearchChange={setFilterObject}
                        searchAttribute={AdministratorFilterSchema.freeTextSearch}
                /> 
                <SMCTable
                    columns={columns}
                    columnsState={columnsState}
                    setColumnsState={setColumnsState}
                    setDefaultColumnsState={setDefaultColumnsState}
                    selectedObjects={selectedObjects}
                    setSelectedObjects={setSelectedObjects}
                    hasCheckAll={true}
                    defaultColumnsWidths={columnsWidths}
                    onEndResizingColumns={setColumnsWidths}
                    content={tableContent}
                    sortBasis={sortBasis}
                    sortDirection={sortDirection}
                    setSort={setSort}
                    loading={isFetching}
                    onRequestLoadPage={fetchNextPage}
                    isLastPage={isLastPage}
                    width={tableWidth}
                    height={tableHeight}
                    rowIdSelector={rowIdSelector}
                    isFilterOpen={isFilterPaneOpen}
                    filterElem={
                        <AdministratorFilterPane
                            initialFilter={filterObject}
                            onFilterChange={setFilterObject}
                            open={isFilterPaneOpen}
                        />
                    }
                    textToHighlight={freeTextSearch}
                    showEditIcon={false}
                />
                {/* Floating windows */}
                <AdministratorWizard
                    isOpen={isNewObjectWindowOpen}
                    onRequestClose={closeNewObjectWindow}
                    onSuccess={newObjectCallback}
                />
            </div>
        </SMCPage>
    );
}

const mapStateToProps = state => ({
    isAdminReadOnly: isAdminReadOnlySelector(state),
    isUserMultiDomainAdmin: isUserMultiDomainAdminSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(AdministratorResults);